module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen3@2x-df158b533edf5d1a54b449b3c69e5380.png";